<template>
    <div class="toggle-wrapper" :class="{ disabled }">
      <div v-if="label" class="label">{{ label }}:</div>
  
      <div class="toggle">
        <div
          v-for="option in options"
          :key="option.value"
          class="option"
          :class="{ active: option.value === value }"
          @click="select(option.value)"
        >
          {{ option.label }}
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  const props = defineProps({
    value: {
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  
  })
  
  const emit = defineEmits(['change'])
  
  const select = (newValue) => {
    if (props.disabled) return;
    if (newValue !== props.value) {
      emit('change', newValue)
    }
  }
  </script>
  
  <style scoped>
  .toggle-wrapper.disabled {
    opacity: 0.7;
    pointer-events: none;
    
  }
  
  .label {
    /* font-size: 32px; */
    font-weight: 500;
    text-align: left;
    margin-bottom: 5px;
  }
  
  .toggle {
    display: flex;
    border: 2px solid #d1d5db;
    border-radius: 9px;
    padding: 3px;
    width: 170px;
    cursor: pointer;
    background: #fff;
    gap: 3px;
  }
  
  .option {
    flex: 1;
    text-align: center;
    padding: 6px 0;
    /* font-size: 48px; */
    font-weight: 600;
    color: #6b7280;
    border-radius: 7px;
    transition: all 0.2s ease;
  }
  
  .option.active {
    background: #0d6efd;
    color: #fff;
  }
  </style>
  